import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/icons/icon_play.svg'


const _withScopeId = n => (_pushScopeId("data-v-3fb2f06c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "video-wrapper"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "playbutton",
  src: _imports_0
}, null, -1))
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "itemCard",
    style: _normalizeStyle(_ctx.gridHeight),
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.selectItem && _ctx.selectItem(...args)))
  }, [
    (_ctx.item.type === _ctx.ItemType.Video)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("img", { src: _ctx.fileURL }, null, 8, _hoisted_3)
        ]))
      : (_openBlock(), _createElementBlock("img", {
          key: 1,
          src: _ctx.fileURL
        }, null, 8, _hoisted_4))
  ], 4))
}